import React, { useState, useEffect } from 'react';
import Preloader from '../../../../general/Preloader'

const UserFormUpdate = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [showPassword, setPassword] = useState(true);
    const [showPasswordConfirmation, setPasswordConfirmation] = useState(true);
        
    const token = document.querySelector("[name='csrf-token']").content;
    const [messageContent, setMessageContent] = useState({ 
        valid: false,
        type: "danger",
        message: "Los campos 'Contraseña' y 'Confirmar contraseña' son obligatorios. Por favor, complétalos para continuar.."
    });

    const [form, setForm] = useState({ 
        password: "",
        password_confirmation: "",
        ...props.user
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const validationForm = () => {
        if (form.password != "" &&
            form.password_confirmation != "" 
        ) {
            setMessageContent({ 
                valid: false, 
                type: "danger",
                message: "Los campos 'Contraseña' y 'Confirmar contraseña' son obligatorios. Por favor, complétalos para continuar.." 
            })
            return true
        }else{
            setMessageContent({ 
                valid: true, 
                type: "danger",
                message: "Los campos 'Contraseña' y 'Confirmar contraseña' son obligatorios. Por favor, complétalos para continuar.." 
            })
            return false
        }
    }

    const handleClick = () => {
        if(validationForm()){
            setIsLoaded(true);

            fetch(`/api/v1/update_user_password`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": token,
                    "authorization": "98a2425c7cd22d4dad50",
                    "Content-Type": "application/json"
                }
            })
    
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                console.log("data", data);
                setIsLoaded(false);
                setMessageContent(data)
            });
        }
    }

    const style = {
        fontSize: 14,
        cursor: "pointer"
    }
    
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12 text-center mb-3">
                    <h3 className='mb-0 text-primary'>{props.user.name}</h3>
                </div>

                <div className="col-md-12 text-center mb-3">
                    <div className="alert alert-primary text-white text-center" role="alert">
                        En esta sección podrás actualizar tu contraseña. Ingresa una nueva contraseña segura y confírmala para completar el proceso.
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="input-group mb-2">
                        <div className="input-group-prepend">
                            <div className="input-group-text"><i style={style} onClick={() => setPassword(!showPassword)} className={`mdi mdi-${showPassword ? "eye-off" : "eye"}-outline`}></i></div>
                        </div>

                        <input 
                            className="form form-control"
                            type={showPassword ? "password" : "text"}  
                            name="password" 
                            value={form.password}
                            onChange={handleChange}
                            placeholder='Contraseña'
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="input-group mb-2">
                        <div className="input-group-prepend">
                            <div className="input-group-text"><i style={style} onClick={() => setPasswordConfirmation(!showPasswordConfirmation)} className={`mdi mdi-${showPasswordConfirmation ? "eye-off" : "eye"}-outline`}></i></div>
                        </div>

                        <input 
                            className="form form-control"
                            type={showPasswordConfirmation ? "password" : "text"}  
                            name="password_confirmation" 
                            value={form.password_confirmation}
                            onChange={handleChange}
                            placeholder='Confirmar contraseña'
                        />
                    </div>
                </div>

                {messageContent.valid && (
                    <div className="col-md-12 mt-3">
                        <div className={`alert alert-${messageContent.type} ${messageContent.type == "danger" ? "text-white" : "text-dark"} text-center`} role="alert">
                            {messageContent.message}
                        </div>
                    </div>    
                )}

                <div className="col-md-12 mt-2 mb-2">
                    <hr />
                </div>
                
                <div className="col-md-12 text-center">
                    {messageContent.type == "danger" && (
                        <button
                            className='btn btn-primary text-white mr-2'
                            onClick={handleClick}
                            disabled={isLoaded}
                        >
                            {isLoaded ? "Actualizando..." : "Actualizar"}
                        </button>
                    )}

                    <button
                        className='btn btn-light text-black'
                        onClick={() => props.toggle()}
                    >
                        Cerrar
                    </button>
                </div>

            </div>
        </React.Fragment>
    );
}


export default UserFormUpdate;

